import { Component, OnInit } from '@angular/core';
import {AngularFireAuth} from '@angular/fire/auth';
import { AppRoutingModule } from '../app-routing.module';
import { Router } from '@angular/router';
import { AngularFirestore } from '@angular/fire/firestore';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {CardService} from '../../shared/card.service';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [AngularFireAuth]
})
export class LoginComponent implements OnInit {
  constructor(public afAuth: AngularFireAuth , private cardService: CardService
              , private firestore: AngularFirestore, public router: Router,
              private modalService: NgbModal) { }
  user: any = {};
  utente: any = {};
  card;


  ngOnInit(){
    this.ReturnCard(); }


  ReturnCard = () =>
    this.cardService
      .getCoffeeOrders()
      .subscribe(res => (this.card = res))


  login(){
    console.log(this.user.email);
    console.log(this.user.password);
    this.afAuth.signInWithEmailAndPassword(this.user.email, this.user.password)
      .then((res: any) => console.log(res))
      .catch((error: any) => console.error(error));

    this.router.navigate(['meeting']);
  }
  open(content) {
    this.modalService.open(content);
  }



}
